import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '../locales/en/translation.json';
import fr from '../locales/fr/translation.json';
import it from '../locales/it/translation.json';
import de from '../locales/de/translation.json';
import nl from '../locales/nl/translation.json';
import es from '../locales/es/translation.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {en, fr, it, de, es, nl},
        fallbackLng: 'en',
        debug: process.env.NODE_ENV !== 'production',
        keySeparator: false,
        returnEmptyString: false
    });

export default i18n;
